import { useState, useEffect, useContext } from "react";
import Title from "./component/Title";
import GlobalContext from "./GlobalContext";
import Axios from "axios";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useSnackbar } from "notistack";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import InputAdornment from "@mui/material/InputAdornment";
import { Dialog, DialogContent, OutlinedInput } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Rules from "./component/Rules";
import TermsAndConditions from "./component/TermsAndConditions";
import Confirmation from "./component/Confirmation";
import RegisterEmail from "./component/emails/registrations";
import { render } from "@react-email/render";
import RegisterEmailReceive from "./component/emails/registrationsReception";

const dayjs = require("dayjs");

// "5145551234" / "+15145551234" -> "514 555 1234" for display.
const formatLocalPhone = (raw) => {
  const digits = String(raw || "").replace(/\D/g, "");
  const local = digits.slice(-10);
  let out = "";
  for (let i = 0; i < local.length; i++) {
    if (i === 3 || i === 6) out += " ";
    out += local[i];
  }
  return out;
};

function Registrations() {
  const { globalURL } = useContext(GlobalContext);
  const url = globalURL;
  const { enqueueSnackbar } = useSnackbar();

  const [seasonDivisionsData, setSeasonDivisionsData] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [birth, setBirth] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [phone, setPhone] = useState("");
  const [emPhone, setEmPhone] = useState("");
  const [jersey, setJersey] = useState("");
  const [jerseyColor, setJerseyColor] = useState("");
  const [jerseyModal, setJerseyModal] = useState(false);
  const [status, setStatus] = useState("");
  const [newPlayer, setNewPlayer] = useState(null);
  const [errorDate, setErrorDate] = useState(null);
  const [matureError, setMatureError] = useState(null);
  const [agreement, setAgreement] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [seasonID, setSeasonID] = useState("");
  const [season, setSeason] = useState(null);
  const [loadingForm, setLoadingForm] = useState(false);

  // --- Wizard: phone -> otp -> account (new only) -> form ---
  const [step, setStep] = useState("phone"); // phone | otp | account | form
  const [otpCode, setOtpCode] = useState("");
  const [regToken, setRegToken] = useState("");
  const [accountExists, setAccountExists] = useState(false);
  const [stepLoading, setStepLoading] = useState(false);
  const [stepError, setStepError] = useState("");
  const [stepInfo, setStepInfo] = useState("");
  const [takenDivisionIds, setTakenDivisionIds] = useState([]);
  const [loggedIn, setLoggedIn] = useState(false);

  const [formData, setFormData] = useState({
    newPlayer: null,
    divisionID: "",
    seasonID: "",
    firstname: "",
    lastname: "",
    birth: "",
    gender: "",
    email: "",
    postalCode: "",
    phone: "",
    work: "",
    status: "",
    jersey: "",
    jerseyColor: "",
    team: "",
    emName: "",
    emRelation: "",
    emPhone: "",
    termsAgreed: false,
  });

  Axios.defaults.withCredentials = true;

  const emailHtml = render(<RegisterEmail registration={formData} />);
  const receiveEmailHtml = render(
    <RegisterEmailReceive registration={formData} />
  );

  const fetchRegistrationsSeason = async () => {
    await Axios.get(url + "/seasons/registrations/season")
      .then(async (response) => {
        if (response.data) {
          setFormData((prev) => ({ ...prev, seasonID: response.data._id }));
          setSeasonID(response.data._id);
          setSeason(response.data);
          await Axios.get(url + "/seasonDivisions/season/" + response.data._id)
            .then(async (response) => {
              setSeasonDivisionsData(response.data);
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            });
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const handleEmailChange = async (event) => {
    const inputValue = event.target.value;
    setEmail(inputValue);

    handleValidation();

    setTimeout(() => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(inputValue)) {
        setError(true);
      } else {
        setError(false);
      }
    }, 1200);
  };

  const handleValidation = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  };

  useEffect(() => {
    fetchRegistrationsSeason();
  }, []);

  // If a player is already logged in, skip the phone/OTP steps entirely and
  // jump straight to the prefilled registration form.
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    Axios.get(url + "/users/reg/prefill", {
      headers: { "auth-token": token },
    })
      .then((res) => {
        applyProfile(res.data.profile);
        setAccountExists(true);
        setLoggedIn(true);
        setTakenDivisionIds(res.data.alreadyRegisteredDivisionIds || []);
        setStep("form");
      })
      .catch(() => {
        // Not a player / not logged in — leave the phone step as-is.
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  const handlePhoneNumberChange = (event) => {
    const rawInput = event.target.value.replace(/\D/g, "");
    const name = event.target.name;
    const trimmedInput = rawInput.slice(0, 10);

    let formattedNumber = "";
    for (let i = 0; i < trimmedInput.length; i++) {
      if (i === 3 || i === 6) {
        formattedNumber += " ";
      }
      formattedNumber += trimmedInput[i];
    }
    if (name === "phone") {
      setPhone(formattedNumber);
      setFormData((prev) => ({ ...prev, phone: formattedNumber }));
    } else if (name === "emPhone") {
      setEmPhone(formattedNumber);
      setFormData((prev) => ({ ...prev, emPhone: formattedNumber }));
    }
  };

  useEffect(() => {
    if (birth) {
      setErrorDate({});
    }
  }, [birth]);

  // ---------------- Wizard actions ----------------

  // Prefill the local field state + formData from the server profile.
  const applyProfile = (profile) => {
    if (!profile) return;
    setEmail(profile.email || "");
    setPhone(formatLocalPhone(profile.phone));
    setEmPhone(formatLocalPhone(profile.emPhone));
    setGender(profile.gender || "");
    setBirth(profile.birth ? new Date(profile.birth) : "");
    setNewPlayer(profile.isReturning ? "false" : "true");
    setFormData((prev) => ({
      ...prev,
      firstname: profile.firstname || "",
      lastname: profile.lastname || "",
      email: profile.email || "",
      phone: formatLocalPhone(profile.phone),
      gender: profile.gender || "",
      birth: profile.birth ? new Date(profile.birth) : "",
      postalCode: profile.postalCode || "",
      work: profile.work || "",
      emName: profile.emName || "",
      emRelation: profile.emRelation || "",
      emPhone: formatLocalPhone(profile.emPhone),
      newPlayer: profile.isReturning ? "false" : "true",
    }));
  };

  const requestOtp = async (e) => {
    e.preventDefault();
    setStepError("");
    setStepInfo("");
    setStepLoading(true);
    try {
      const res = await Axios.post(url + "/users/reg/request-otp", { phone });
      setAccountExists(Boolean(res.data.accountExists));
      setStepInfo("We texted you a 6-digit code.");
      setStep("otp");
    } catch (err) {
      setStepError(
        typeof err?.response?.data === "string"
          ? err.response.data
          : "Could not send a code."
      );
    } finally {
      setStepLoading(false);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    setStepError("");
    setStepLoading(true);
    try {
      const res = await Axios.post(url + "/users/reg/verify-otp", {
        phone,
        code: otpCode,
      });
      setRegToken(res.data.regToken);
      setAccountExists(Boolean(res.data.accountExists));
      setTakenDivisionIds(res.data.alreadyRegisteredDivisionIds || []);
      applyProfile(res.data.profile);
      // Existing account -> straight to the (prefilled) registration form.
      // New number -> collect account info first.
      setStep(res.data.accountExists ? "form" : "account");
    } catch (err) {
      setStepError(
        typeof err?.response?.data === "string"
          ? err.response.data
          : "Incorrect code."
      );
    } finally {
      setStepLoading(false);
    }
  };

  const submitAccount = async (e) => {
    e.preventDefault();
    setStepError("");
    setStepLoading(true);
    try {
      const res = await Axios.post(url + "/users/reg/account", {
        regToken,
        firstname: formData.firstname,
        lastname: formData.lastname,
        email: email,
        gender: gender,
        birth: birth || null,
        postalCode: formData.postalCode,
        emName: formData.emName,
        emRelation: formData.emRelation,
        emPhone: emPhone,
      });
      applyProfile(res.data.profile);
      // Auto-login with the session the server just issued.
      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("refresh", res.data.refreshToken);
        setLoggedIn(true);
      }
      setAccountExists(true);
      enqueueSnackbar("Account created! You're signed in.", {
        variant: "success",
      });
      setStep("form");
    } catch (err) {
      setStepError(
        typeof err?.response?.data === "string"
          ? err.response.data
          : "Could not save your account."
      );
    } finally {
      setStepLoading(false);
    }
  };

  // Divisions this phone hasn't registered for yet.
  const availableDivisions = seasonDivisionsData.filter(
    (sd) => !takenDivisionIds.includes(String(sd.divisionID?._id))
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    if (birth === null || birth === "") {
      setErrorDate({ helperText: "Input is required", error: true });
      return;
    }
    setErrorDate({});
    const startDate = new Date(birth);
    const currentDate = new Date();
    const mature =
      (currentDate.getFullYear() - startDate.getFullYear()) * 12 +
        (currentDate.getMonth() - startDate.getMonth()) >=
      215;

    if (!mature) {
      setMatureError({ helperText: "Must be over 18.", error: true });
      return;
    }
    setMatureError({});

    const payload = {
      ...formData,
      birth,
      termsAgreed: agreement,
      firstname: (formData.firstname || "").trim(),
      lastname: (formData.lastname || "").trim(),
    };
    setLoadingForm(true);
    postRegister(payload);
    setTimeout(() => {
      setLoadingForm(false);
    }, 3000);
  };

  const sendEmail = async (mailOptions) => {
    await Axios.post(url + "/emails", { mailOptions }).then((response) => {});
  };

  const receiveEmail = async (mailOptions) => {
    await Axios.post(url + "/emails", { mailOptions }).then((response) => {});
  };

  const postRegister = async (data) => {
    const config = loggedIn
      ? { headers: { "auth-token": localStorage.getItem("token") } }
      : {};
    await Axios.post(url + "/registrations/self", { ...data, regToken }, config)
      .then(async (response) => {
        const mailOptions = {
          from: "info@afterworkleagues.com",
          to: data.email,
          subject: "Registration request Afterwork - ",
          html: emailHtml,
        };
        sendEmail(mailOptions);

        const mailOptions2 = {
          from: "info@afterworkleagues.com",
          to: "info@afterworkleagues.com",
          subject: "Registration request Afterwork - ",
          html: receiveEmailHtml,
        };
        receiveEmail(mailOptions2);

        if (response.data?.alreadyRegisteredDivisionIds) {
          setTakenDivisionIds(response.data.alreadyRegisteredDivisionIds);
        }
        setCompleted(true);
      })
      .catch((error) => {
        const msg =
          typeof error?.response?.data === "string"
            ? error.response.data
            : "Something went wrong submitting your registration.";
        enqueueSnackbar(msg, { variant: "error" });
        console.error("Error submitting registration:", error);
      });
  };

  // Reset the division-specific fields to register for another division.
  const registerAnotherDivision = () => {
    setCompleted(false);
    setSelectedDivision("");
    setStatus("");
    setJersey("");
    setJerseyColor("");
    setAgreement(false);
    setFormData((prev) => ({
      ...prev,
      divisionID: "",
      status: "",
      jersey: "",
      jerseyColor: "",
      team: "",
      termsAgreed: false,
    }));
    setStep("form");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "jersey" && value === "economic") {
      setOpen(true);
    }
  };

  const handleAgreement = (value) => {
    setAgreement(value);
  };

  const remainingDivisions = availableDivisions.length;

  return (
    <div className="container ">
      {jerseyModal && (
        <div className="w-screen z-30 h-screen fixed bg-black bg-opacity-50 flex justify-center item-center">
          <div className="p-1 h-fit border-[4px] border-black bg-red-500 mt-24">
            <div className="sm:py-1 lg:py-4 sm:px-1 lg:px-8 border-[2px] border-black lg:text-left sm:text-center text-sm bg-black">
              <h1 className="font-semibold px-2">Important Note</h1>
              <p className="sm:px-2 lg:px-4 py-2">
                Make sure to pick the same jersey as your teammates.
              </p>
              <div className="flex justify-center items-center">
                <button
                  onClick={() => {
                    setJerseyModal(false);
                  }}
                  className="bg-black m-2 border-white border-2 hover:bg-slate-100 hover:bg-opacity-20 p-4 "
                >
                  Understood.
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="bgRed fade-in sm:w-[85%] lg:w-[60%] relative flex justify-center flex-col items-center p-4 border-black border-8 rounded-3xl my-8 sm-shadow">
        <Title word="Join Us!" />
      </div>
      {seasonID === "" ? (
        <div className="content fade-in my-8 justify-start items-center sm:w-[95%] lg:w-[80%] sm:px-0 lg:pl-10 lg:pr-10 pt-10 pb-10 black-bg  border-black border-8">
          <Title word={"Comeback"}></Title>
          <Title word={"soon"}></Title>
        </div>
      ) : loadingForm ? (
        <div className="bgRed sm:w-[85%] lg:w-[60%] relative flex justify-center flex-col items-center p-4 border-black border-8 rounded-3xl my-8 sm-shadow">
          <CircularProgress sx={{ color: "white" }}></CircularProgress>
        </div>
      ) : (
        <div className="content fade-in my-8 justify-start items-center sm:w-[95%] lg:w-[80%] sm:px-0 lg:pl-10 lg:pr-10 pt-10 pb-10 black-bg  border-black border-8">
          <div className="relative text-center w-fit sm:m-8 lg:m-12 text-4xl font-extrabold stats-font p-2">
            {seasonDivisionsData[0]?.seasonID.name}
            <span className="absolute w-[100%] h-1 bottom-0 left-[-50%] translate-x-[50%] rounded-full bg-white"></span>
          </div>

          {completed ? (
            <div className="flex flex-col items-center gap-6 w-full">
              <Confirmation email={formData.email}></Confirmation>
              {remainingDivisions > 0 && (
                <Button
                  onClick={registerAnotherDivision}
                  variant="outlined"
                  sx={{ color: "white", borderColor: "white" }}
                >
                  Register for another division
                </Button>
              )}
            </div>
          ) : step === "phone" ? (
            <StepShell
              heading="Let's get you registered"
              sub="Enter your mobile number to start. We'll text you a code."
            >
              <form onSubmit={requestOtp} className="flex flex-col gap-4">
                <TextField
                  label="Mobile Phone"
                  name="phone"
                  type="tel"
                  autoComplete="tel"
                  value={phone}
                  onChange={handlePhoneNumberChange}
                  required
                />
                {stepError && (
                  <strong className="text-red-500 text-center">
                    {stepError}
                  </strong>
                )}
                <Button variant="outlined" type="submit" disabled={stepLoading}>
                  {stepLoading ? "Sending..." : "Text me a code"}
                </Button>
              </form>
            </StepShell>
          ) : step === "otp" ? (
            <StepShell
              heading={accountExists ? "Welcome back!" : "Verify your number"}
              sub={
                accountExists
                  ? "Enter the code we texted to confirm it's you."
                  : "Enter the code we texted. Then we'll set up your account."
              }
            >
              <form onSubmit={verifyOtp} className="flex flex-col gap-4">
                {stepInfo && (
                  <span className="text-green-400 text-sm text-center">
                    {stepInfo}
                  </span>
                )}
                <TextField
                  label="6-digit code"
                  inputProps={{ inputMode: "numeric", maxLength: 6 }}
                  autoComplete="one-time-code"
                  value={otpCode}
                  onChange={(e) =>
                    setOtpCode(e.target.value.replace(/\D/g, "").slice(0, 6))
                  }
                  required
                />
                {stepError && (
                  <strong className="text-red-500 text-center">
                    {stepError}
                  </strong>
                )}
                <Button variant="outlined" type="submit" disabled={stepLoading}>
                  {stepLoading ? "Verifying..." : "Verify"}
                </Button>
                <Button
                  variant="text"
                  type="button"
                  onClick={() => {
                    setStep("phone");
                    setOtpCode("");
                    setStepError("");
                  }}
                >
                  Use a different number
                </Button>
              </form>
            </StepShell>
          ) : step === "account" ? (
            <StepShell
              heading="Create your account"
              sub="We'll save this so future registrations are pre-filled."
            >
              <form onSubmit={submitAccount} className="flex flex-col gap-4">
                <TextField
                  label="First Name"
                  name="firstname"
                  value={formData.firstname}
                  onChange={handleChange}
                  required
                />
                <TextField
                  label="Last Name"
                  name="lastname"
                  value={formData.lastname}
                  onChange={handleChange}
                  required
                />
                <TextField
                  label="Email"
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  error={Boolean(error) && email !== ""}
                  required
                />
                <div className="flex gap-4">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                      value={birth ? dayjs(birth) : null}
                      onChange={(e) => {
                        // @ts-ignore
                        setBirth(e?.$d ? e.$d : null);
                      }}
                      maxDate={dayjs(Date.now())}
                      slotProps={{
                        textField: {
                          required: true,
                          label: "Birthdate",
                          name: "birth",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel required id="acc-gender-label">
                      Sex At Birth
                    </InputLabel>
                    <Select
                      labelId="acc-gender-label"
                      label={"Sex At Birth"}
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                      required
                    >
                      <MenuItem value={"Male"}>Male</MenuItem>
                      <MenuItem value={"Female"}>Female</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <TextField
                  label="Postal Code"
                  name="postalCode"
                  value={formData.postalCode}
                  onChange={handleChange}
                />
                <h1 className="text-lg mt-2">EMERGENCY CONTACT</h1>
                <TextField
                  label="Full Name"
                  name="emName"
                  value={formData.emName}
                  onChange={handleChange}
                  required
                />
                <TextField
                  label="Relationship To Player"
                  name="emRelation"
                  value={formData.emRelation}
                  onChange={handleChange}
                  required
                />
                <TextField
                  label="Phone Number"
                  name="emPhone"
                  value={emPhone}
                  onChange={handlePhoneNumberChange}
                  required
                />
                {stepError && (
                  <strong className="text-red-500 text-center">
                    {stepError}
                  </strong>
                )}
                <Button variant="outlined" type="submit" disabled={stepLoading}>
                  {stepLoading ? "Saving..." : "Continue to registration"}
                </Button>
              </form>
            </StepShell>
          ) : remainingDivisions === 0 ? (
            <StepShell
              heading="You're all set"
              sub="You've already registered for every division available this season. See you on the court!"
            >
              <div></div>
            </StepShell>
          ) : (
            <div className="flex sm:flex-col lg:flex-row justify-between w-full p-4 h-fit border-2 border-white">
              <form
                onSubmit={handleSubmit}
                className="flex sm:flex-col lg:flex-row m-1 p-4 w-full gap-8"
              >
                <div className="flex flex-col sm:w-full lg:w-1/2 gap-4 font-Poppins">
                  <h1 className="sm:mx-1 m-3 text-lg">PLAYER INFORMATION</h1>
                  <FormControl>
                    <FormLabel required>New Player?</FormLabel>
                    <RadioGroup
                      row
                      name="newPlayer"
                      value={newPlayer}
                      onChange={(e) => {
                        setNewPlayer(e.target.value);
                        handleChange(e);
                      }}
                    >
                      <FormControlLabel
                        value={"true"}
                        control={<Radio required={true} />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={"false"}
                        control={<Radio required={true} />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <FormControl>
                    <InputLabel required id="division-label">
                      Division
                    </InputLabel>
                    <Select
                      labelId="division-label"
                      label={"Division"}
                      onChange={(e) => {
                        setSelectedDivision(e.target.value);
                        handleChange(e);
                      }}
                      value={selectedDivision}
                      name="divisionID"
                      required
                    >
                      {availableDivisions?.map((seasonDivision, index) => (
                        <MenuItem
                          value={seasonDivision.divisionID._id}
                          key={index}
                        >
                          {seasonDivision.divisionID.titleEn} (
                          {seasonDivision.divisionID.price}$)
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label="First Name"
                    name="firstname"
                    variant="outlined"
                    value={formData.firstname}
                    onChange={handleChange}
                    required
                  />
                  <TextField
                    label="Last Name"
                    name="lastname"
                    variant="outlined"
                    value={formData.lastname}
                    onChange={handleChange}
                    required
                  />
                  <div className="flex gap-4">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDatePicker
                        value={birth ? dayjs(birth) : null}
                        onChange={(e) => {
                          // @ts-ignore
                          setBirth(e?.$d ? e.$d : null);
                        }}
                        maxDate={dayjs(Date.now())}
                        slotProps={{
                          textField: {
                            required: true,
                            label: "Birthdate",
                            name: "birth",
                            ...errorDate,
                          },
                        }}
                      />
                    </LocalizationProvider>

                    <FormControl sx={{ width: "100%" }}>
                      <InputLabel required id="Gender-label">
                        Sex At Birth
                      </InputLabel>
                      <Select
                        labelId="Gender-label"
                        label={"*Sex At Birth"}
                        value={gender}
                        onChange={(e) => {
                          setGender(e.target.value);
                          handleChange(e);
                        }}
                        required
                        name="gender"
                      >
                        <MenuItem value={"Male"}>Male</MenuItem>
                        <MenuItem value={"Female"}>Female</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <FormControl>
                    <InputLabel id="email-label" required>
                      Email
                    </InputLabel>
                    <OutlinedInput
                      label="Email"
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => {
                        handleEmailChange(e);
                        handleChange(e);
                      }}
                      error={Boolean(error) && email !== ""}
                      required
                      endAdornment={
                        <InputAdornment position="end">
                          {email === "" ? (
                            <div></div>
                          ) : loading ? (
                            <CircularProgress size={20} />
                          ) : error ? (
                            <CloseIcon color="error"></CloseIcon>
                          ) : (
                            <DoneIcon></DoneIcon>
                          )}
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  <TextField
                    label="Postal Code"
                    variant="outlined"
                    name="postalCode"
                    value={formData.postalCode}
                    onChange={handleChange}
                  />
                  <TextField
                    label="Phone Number"
                    value={phone}
                    name="phone"
                    variant="outlined"
                    onChange={handlePhoneNumberChange}
                    required
                    disabled
                  ></TextField>
                  <TextField
                    label="Work Area"
                    variant="outlined"
                    name="work"
                    value={formData.work}
                    onChange={handleChange}
                  />
                </div>
                <div className="flex flex-col sm:w-full lg:w-1/2 gap-4 font-Poppins border-">
                  <h1 className="lg:m-2 sm:hidden lg:block select-none text-transparent text-lg">
                    {" "}
                    no title
                  </h1>
                  <FormControl>
                    <FormLabel required>Status</FormLabel>
                    <RadioGroup
                      row
                      name="status"
                      value={status}
                      onChange={(e) => {
                        setStatus(e.target.value);
                        handleChange(e);
                      }}
                    >
                      <FormControlLabel
                        value="Alone"
                        control={<Radio required={true} />}
                        label="Alone"
                      />
                      <FormControlLabel
                        value="Part of a team"
                        control={<Radio required={true} />}
                        label="Part of a team"
                      />
                    </RadioGroup>
                  </FormControl>
                  {status === "Part of a team" && (
                    <TextField
                      className="fade-in"
                      label="Team Name"
                      name="team"
                      value={formData.team}
                      onChange={handleChange}
                      variant="outlined"
                      required
                    />
                  )}

                  <FormControl>
                    <InputLabel id="jersey-label">Jersey Size *</InputLabel>
                    <Select
                      labelId="jersey-label"
                      label={"Jersey Size *"}
                      onChange={(e) => {
                        setJersey(e.target.value);
                        handleChange(e);
                      }}
                      value={jersey}
                      name="jersey"
                      required
                    >
                      {season?.previousJersey && (
                        <MenuItem value={"economic"}>
                          Last season's Jersey (20$ Off)
                        </MenuItem>
                      )}
                      <MenuItem value={"(S)"}>(S)</MenuItem>
                      <MenuItem value={"(M)"}>(M)</MenuItem>
                      <MenuItem value={"(L)"}>(L)</MenuItem>
                      <MenuItem value={"(XL)"}>(XL)</MenuItem>
                      <MenuItem value={"(2XL)"}>(2XL)</MenuItem>
                      <MenuItem value={"(3XL)"}>(3XL)</MenuItem>
                      <MenuItem value={"(4XL)"}>(4XL)</MenuItem>
                    </Select>
                  </FormControl>

                  {jersey !== "economic" && (
                    <FormControl>
                      <InputLabel id="jerseyColor-label">
                        Jersey Color *
                      </InputLabel>
                      <Select
                        labelId="jerseyColor-label"
                        label={"Jersey Color *"}
                        onChange={(e) => {
                          setJerseyColor(e.target.value);
                          setJerseyModal(true);
                          handleChange(e);
                        }}
                        value={jerseyColor}
                        name="jerseyColor"
                        required
                      >
                        <MenuItem value={"10thAnniversary"}>
                          10th Anniversary - Black &amp; Gold{" "}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  <h1 className="m-[14px] text-lg">
                    MEDICAL/EMERGENCY CONTACT INFORMATION
                  </h1>

                  <TextField
                    label="Full Name"
                    name="emName"
                    variant="outlined"
                    value={formData.emName}
                    onChange={handleChange}
                    required
                  />
                  <TextField
                    label="Relationship To Player"
                    name="emRelation"
                    variant="outlined"
                    value={formData.emRelation}
                    onChange={handleChange}
                    required
                  />
                  <TextField
                    label="Phone Number"
                    name="emPhone"
                    value={emPhone}
                    variant="outlined"
                    onChange={handlePhoneNumberChange}
                    required
                  />
                  <div className="p-1  border-[4px] border-black bg-red-500">
                    <div className="sm:py-1 lg:py-4 sm:px-1 lg:px-8 border-[2px] border-black lg:text-left sm:text-center text-sm bg-black">
                      <h1 className="font-semibold px-2">Important Note</h1>
                      <p className="sm:px-2 lg:px-4 py-2">
                        PAIEMENT MUST BE DONE BY INTERAC TRANSFER AT
                        Info@afterworkleagues.com
                      </p>
                      <p className="px-4">Question: League name</p>
                      <p className="px-4">Answer: Afterwork</p>
                    </div>
                  </div>

                  <div className="flex sm:flex-col lg:flex-row p-4 justify-center items-center gap-8">
                    <Rules />
                    <TermsAndConditions agreed={handleAgreement} />
                  </div>
                  <p className="text-center text-red-600 font-bold">
                    {errorDate?.helperText && "Birthdate is Required *"}
                    {matureError?.helperText}
                  </p>

                  <div className="flex justify-center">
                    <Button
                      sx={{
                        width: "80%",
                        fontWeight: 800,
                        border: "solid 4px black",
                        background: "white",
                        color: "black",
                        fontFamily: "Poppins",
                        "&:hover": { backgroundColor: "#e0e0e0" },
                      }}
                      type="submit"
                      variant="contained"
                      size="large"
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      )}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogContent
          sx={{ border: "4px solid red", fontWeight: 600, textAlign: "center" }}
        >
          This applies only if you come back with a jersey from the prior
          season.
        </DialogContent>
      </Dialog>
    </div>
  );
}

// Centered card wrapper for the phone / otp / account steps.
function StepShell({ heading, sub, children }) {
  return (
    <div className="flex justify-center w-full">
      <div className="flex flex-col gap-4 max-w-[360px] w-full p-2">
        <h1 className="text-2xl font-extrabold text-center">{heading}</h1>
        {sub && <p className="text-white/60 text-sm text-center -mt-2">{sub}</p>}
        {children}
      </div>
    </div>
  );
}

export default Registrations;
